import momentDur from '../moment';

export const formatDuration = (duration: number) => momentDur.duration(duration, 'seconds').format('m:ss', { trim: false });